import { Productor, ProductorResponse } from '../models/OtherWork';

export const productorMapper = (productor: ProductorResponse): Productor => {
    return {
        name: productor?.name ?? '',
        link: productor?.link ?? '',
    };
};
